// Returns the in-app path for a deep link, stripping external origins. Returns null when unusable.
export const getNotificationPath = (deepLink: string | null | undefined): string | null => {
  const trimmed = deepLink?.trim();
  if (!trimmed) return null;

  // Reject protocol-relative '//host' — it points at an external origin.
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return trimmed;
  }

  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    const path = `${url.pathname}${url.search}${url.hash}`;
    if (path.startsWith('//')) return null;
    return path;
  } catch {
    return null;
  }
};
